import React from 'react';

import Context from '../../../../../../context';

import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';
import { CustomDropdownFilter, CustomButton2, LocationDropdowns } from '../../../../../../components';

import './index.sass';
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import values from "../../../../../../values";

const Filter: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));
  const { setRequestArea, requestArea } = React.useContext(Context.Location.Area);
  const [ selectedCity, setSelectedCity ] = React.useState<locationNamespace.city.index | undefined>(undefined);
  const [ selectedProvince, setSelectedProvince ] = React.useState<locationNamespace.province.index | undefined>(undefined);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onSelectProvince(province: locationNamespace.province.index | undefined): void {
    setSelectedProvince(province);
    if (!province) return setRequestArea!({
      ...requestArea,
      province: undefined,
      page: 1,
    });
    setRequestArea!({
      ...requestArea,
      province: province._id,
      page: 1,
    });
  }

  function onSelectCity(city: locationNamespace.city.index | undefined): void {
    setSelectedCity(city);
    if (!city) return setRequestArea!({
      ...requestArea,
      city: undefined,
      page: 1,
    });
    setRequestArea!({
      ...requestArea,
      city: city._id,
      page: 1,
    });
  }

  function handleOnClickReFetch(): void {
    setSelectedProvince(undefined);
    setSelectedCity(undefined);
    setRequestArea!({ page: 1, limit: 10 });
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (userType !== 'ADMIN') return <></>;
  return (
    <div className='filter-container'>
      <CustomDropdownFilter title={t('filter')} hoverTitle={t('filter')}>
        <LocationDropdowns.Province defaultItem={selectedProvince} onSelectItem={onSelectProvince} />
        <LocationDropdowns.City
          defaultItem     = { selectedCity     }
          onSelectItem    = { onSelectCity     }
          selectedProvince= { selectedProvince }
        />
        <div className='filter-footer'>
          <CustomButton2 onClick={handleOnClickReFetch} title={t('reset')} type='primary'/>
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Filter;
